"use client";

import dynamic from "next/dynamic";
import { Suspense } from "react";

const MapView = dynamic(() => import("./MapView"), {
	ssr: false,
});

export default function MapPage() {
	return (
		<Suspense
			fallback={
				<div className="bg-black min-h-screen flex items-center justify-center">
					<div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin" />
				</div>
			}
		>
			<MapView />
		</Suspense>
	);
}
